import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../service/apiservice/login.service';
declare var $;
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-doctorsidenav',
  templateUrl: './doctorsidenav.component.html',
  styleUrls: ['./doctorsidenav.component.css']
})
export class DoctorsidenavComponent implements OnInit {
  tabList: any;
  selected: any;
  selectedPath: any;
  constructor(private loginService:LoginService,private router: Router) { }

  ngOnInit() {
    localStorage.setItem("Active Route",this.router.url);
    this.loadScript();
 
    this.selected = 'User List';
    this.tabList = [
      { path: 'doctorpage', content: 'User List' },
      { path: 'campregistration', content: 'Camp Registration' },
      { path: 'multiuserregistration', content: 'Multi User Registration'},

    ];
  }
  public loadScript() {
    let body = <HTMLDivElement>document.body;
    let script = document.createElement('script');
    script.innerHTML = '';
    script.src = 'assets/js/app-script.js';
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  }
  select(item, path) {
    debugger;
    this.selectedPath = path;
    this.selected = item;
    if (window.innerWidth <= 600) {
      $("#wrapper").toggleClass("toggled");
    }
    this.router.navigate(['doctordashboard/'+this.selectedPath]);
  }
  isActive(item) {
    return item;
  };


}
